import localforage from '../utils/localforage';
import http from '../utils/api';
import moment from 'moment';

export function getHollydays(ano = moment().format('YYYY')) {
    return http.get('feriados-sede', {
        params: {
            dtInicio: moment(`${ano}-01-01`).subtract(1, 'year').format('YYYY-MM-DD'),
            dtFim:  moment(`${ano}-12-31`).add(1, 'year').format('YYYY-MM-DD'),
        }
    }).then( async ({data}) => {
        await localforage.setItem('hollydays', data?.data ?? [])
    }).catch(async () => {
        await localforage.setItem('hollydays', [])
    });
}
